import { SpectrogramDouble } from '../src/specgram_double'
import { Spectrogram } from '../src/specgram'
import { TimePlot } from '../src/timeplot'
import { App, AudioSource } from '../src/data_source'

const fftSize = 4096;

const spec: SpectrogramDouble = new SpectrogramDouble("spec", document.getElementById("specgram"), 2400, fftSize/2, 44100/2, 10e-0, 255, {"colorbar": true});
// const spec: Spectrogram = new Spectrogram("spec", document.getElementById("specgram"), 1200, fftSize/2, 48000/2, 10e-0, 255, 1200, 1200);

const source = new AudioSource(fftSize);

const app = new App();

var button = document.createElement("button");
button.innerHTML = "Use Song";

var body = document.getElementsByTagName("body")[0];
body.prepend(button);

button.addEventListener ("click", function() {
  button.parentNode.removeChild(button);
  button2.parentNode.removeChild(button2);
  source.useMic = false;
  app.run(source, [spec]);
});


var button2 = document.createElement("button");
button2.innerHTML = "Use Microphone";

body.prepend(button2);

button2.addEventListener ("click", function() {
  button.parentNode.removeChild(button);
  button2.parentNode.removeChild(button2);
  source.useMic = true;
  app.run(source, [spec]);
});
